import { render, staticRenderFns } from "./TaxTransferSummary.vue?vue&type=template&id=8eab5278&scoped=true&"
import script from "./TaxTransferSummary.vue?vue&type=script&lang=js&"
export * from "./TaxTransferSummary.vue?vue&type=script&lang=js&"
import style0 from "./TaxTransferSummary.vue?vue&type=style&index=0&id=8eab5278&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eab5278",
  null
  
)

export default component.exports